import HelpdeskGraphQL from "./HelpdeskGraphQL";
import Axios from "axios";
import { HELPDESK_SERVICE_URL } from "../config";

class File extends HelpdeskGraphQL {
    static async upload(file) {
        const mutationName = 'fileUpload'

        const fd = new FormData();

        const query = `
            mutation ${mutationName}($file: Upload) {
                ${mutationName}(file: $file)
            }
        `
        const variables = {
            file
        }

        fd.append('operations', JSON.stringify({ query, variables }));
        fd.append('map', JSON.stringify({ '0': ['variables.file'] }));
        fd.append(0, file);

        const { data, errors } = await Axios.post(HELPDESK_SERVICE_URL, fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        if (errors && errors.length > 0) {
            throw new Error(errors[0].message)
        }

        return data['data']['fileUpload'];
    }

    static async delete(files) {
        const queryName = 'deleteMessengerFilesUploaded'

        const query = `
            mutation ${queryName}($files: [String]!) {
                ${queryName}(files: $files)
            }
        `
        const variables = {
            files
        }

        return await this.run({ query, variables, queryName });
    }

    static getUploadUrl() {
        return HELPDESK_SERVICE_URL;
    }

    static getUploadProps(file={}) {
        const mutationName = 'fileUpload'
        const fd = {};
        const query = `
            mutation ${mutationName}($file: Upload) {
                ${mutationName}(file: $file)
            }
        `
        const variables = {
            file
        }

        fd.operations = JSON.stringify({ query, variables });
        fd.map = JSON.stringify({ '0': ['variables.file'] });
        return fd;
    }
}

export default File;